import { Component } from '@angular/core';
import template from './fourty-one-p.component.html';
import styles from './fourty-one-p.component.scss';

@Component({
  selector: 'fourty-one-p',
  template,
  styles: [styles]
})
class FourtyOnePComponent {
  constructor() {
    this.jsData = '';
    this.hdmData = '';
  }

  ngOnInit() {
    if (window.adx) {
      window.adx.initiate({
        onInitialize: (hdm) => {
          this.hdmData = hdm;
        },
        onValidate: (javascriptData) => {
          this.jsData = javascriptData;
        },
      });
    }
  }
}

export { FourtyOnePComponent };
